import React from 'react'
import { Store } from 'redux'
import { ThemeProvider } from 'styled-typed'
import { Provider } from 'react-redux'
import { defaultTheme } from 'theme'
import { State } from 'store'
import Routes from 'routes'
import { ConfiguredToaster } from 'uiComponents/message'

interface AppProps {
    store: Store<State>
}

export class App extends React.Component<AppProps, {}> {
    render() {
        return (
            <Provider store={this.props.store}>
                <ThemeProvider theme={defaultTheme}>
                    <Routes />
                    <ConfiguredToaster />
                </ThemeProvider>
            </Provider>
        )
    }
}

export default App
